import React, {useEffect, createContext, useReducer} from 'react';
import { FETCH_DATA_REQUEST, DISPLAY_ERROR_MESSAGE, FETCH_DATE_CONFIG, RESET_MODEL_AND_ERROR_FLAGS, SET_LOADING_FALSE } from '../actions/actionTypes';
import { fetchMetaData } from '../actions/actionSelectors';
import { calendarReportsReducer } from '../actions/calendar-reports-reducer';

const initialState = {
    sessionTimeoutLimit: null,
    idleTimeoutLimit: null,
    errorMessage: "",   
    isError: false,
    modelHeaderTitle: null,
    showModel: false,
    isLoading : false,
    minDate : null,
    maxDate : null
}
    
export const CalendarReportsContext = createContext();

export function CalendarReportsProvider(props) {

    const [state, dispatch] = useReducer(calendarReportsReducer, initialState);
    const { sessionTimeoutLimit, idleTimeoutLimit, isLoading, errorMessage, isError, modelHeaderTitle,
        showModel, minDate, maxDate } = state;
    
    useEffect(() => {
        props.setSelectedNavItem(window.location.pathname.replace(/[/]/g, ''));   
        dispatch({ type: FETCH_DATA_REQUEST, payload: { isError: false, errorMessage: "" } });     
        async function fetchMetaDataAsync() {
            await fetchMetaData()
                .then((data) => {
                    dispatch({
                        type: FETCH_DATE_CONFIG,
                        payload: {                            
                            sessionTimeoutLimit: data.sessionTimeoutLimit ? +(data.sessionTimeoutLimit) : null,
                            idleTimeoutLimit: data.sessionTimeoutLimit ? +(data.idleTimeoutLimit) : null,
                            minDate : data.FromMinDate,
                            maxDate : data.ToMaxDate,
                        }
                    });
                })
        }
        fetchMetaDataAsync();               
    }, []);  

    const resetSubmittedAndErrorFlags = () => {
        dispatch({ type: RESET_MODEL_AND_ERROR_FLAGS }); 
        props.setLogoutFalse();
    }      
    
    const setIsLoading = (flag) => { dispatch({ type: SET_LOADING_FALSE, payload: { isLoading : flag } }); }    
    
    const errorOrWarningHandler = (isModelError, errorModelMessage, showErrorModel, modelHeaderTitleError) => {
        dispatch({
            type: DISPLAY_ERROR_MESSAGE,
            payload: {
                isError: isModelError,
                errorMessage: errorModelMessage,                
                showModel: showErrorModel,
                modelHeaderTitle: modelHeaderTitleError              
            }
        });
    }  

    const provider = {
        sessionTimeoutLimit,
        idleTimeoutLimit,
        errorMessage, 
        isError,
        modelHeaderTitle,
        showModel,
        resetSubmittedAndErrorFlags,        
        errorOrWarningHandler,
        isLoading,
        setIsLoading,
        maxDate,
        minDate
    };

    return (
        <CalendarReportsContext.Provider value={provider}>
            {props.children}
        </CalendarReportsContext.Provider>
    );
}
